import firebase from "firebase/app";
// ? Uncomment if Google Analytics is enabled.
// import "firebase/analytics";
import "firebase/auth";
import { config } from "./config";
import * as firebaseUI from "firebaseui";

const firebaseConfig = {
  apiKey: config.firebase.ApiKey,
  appId: config.firebase.AppId,
  authDomain: config.firebase.AuthDomain,
  // ? Uncomment if Google Analytics is enabled.
  // measurementId: config.firebase.MeasurementId,
  messagingSenderId: config.firebase.MessagingSenderId,
  projectId: config.firebase.ProjectId,
  storageBucket: config.firebase.StorageBucket,
};

export const firebaseApp = firebase.initializeApp(firebaseConfig);

const authUI = new firebaseUI.auth.AuthUI(firebase.auth());

export function startAuthUI(selector: string | Element): void {
  authUI.start(selector, {
    signInOptions: [firebase.auth.EmailAuthProvider.PROVIDER_ID],
    callbacks: {
      signInSuccessWithAuthResult(): boolean {
        return false;
      },
    },
  });
}
